import { IFormViewForm } from 'components/FormView';

const ReceiptConfirmationForm: IFormViewForm = {
    id: 'ReceiptConfirmationForm',
    layout: {
        rows: 1,
        columns: 1
    },
    fields: [
        {
            id: '1',
            position: {
                row: 1,
                col: 1,
                colspan: 3
            },
            type: 'PAPER_CONTAINER',
            props: {
                elevation: 0
            },
            children: [
                {
                    id: 0,
                    type: 'TOGGLE_FIELD',
                    visible: true,
                    style: {
                        display: 'inline-block',
                        width: '35%',
                    },
                    props: {
                        name: 'PrintCredit',
                        label: 'Credit note'
                    }
                },
                {
                    id: 1,
                    type: 'DOCUMENT_OUTPUT_FIELD',
                    visible: true,
                    style: {
                        display: 'inline-block',
                        width: '65%',
                    },
                    props: {
                        size: 'large',
                        label: 'Print to printer',
                        name: 'CreditNoteOutput',
                        fieldId: 'CreditNoteOutput',
                        documentType: 'CN',
                        precedentFields: ['PrintCredit'],
                    }
                },
                {
                    id: 2,
                    type: 'TOGGLE_FIELD',
                    visible: true,
                    style: {
                        display: 'inline-block',
                        width: '35%',
                    },
                    props: {
                        name: 'TransmitCreditNote',
                        label: 'Transmit'
                    }
                },
                {
                    id: 3,
                    type: 'TEXT_FIELD',
                    style: {
                        display: 'inline-block',
                        width: '59%',
                    },
                    props: {
                        label: '',
                        name: 'TransmitVia',
                        placeholder: '',
                        size: 'large',
                        required: false
                    }
                },
                {
                    id: 4,
                    type: 'TOGGLE_FIELD',
                    visible: true,
                    style: {
                        display: 'inline-block',
                        width: '35%',
                    },
                    props: {
                        name: 'PrintDocketCreditNote',
                        label: 'Docket',
                    }
                },
                {
                    id: 5,
                    type: 'DOCUMENT_OUTPUT_FIELD',
                    visible: true,
                    style: {
                        display: 'inline-block',
                        width: '65%',
                    },
                    props: {
                        size: 'large',
                        label: 'Print to printer',
                        name: 'DocketOutput',
                        fieldId: 'DocketOutput',
                        documentType: 'CN',
                        precedentFields: ['PrintDocketCreditNote'],
                    }
                },
                {
                    id: 6,
                    type: 'DIVIDER',
                    props: {
                    }
                },
                {
                    id: 7,
                    type: 'TYPOGRAPHY',
                    props: {
                        text: '',
                        type: 'custom',
                        icon: 'Warning',
                        iconColor: '#a07800',
                        name: 'AlertMessage'
                    }
                },
                {
                    id: 8,
                    type: 'EX_LOOKUP_FIELD',
                    props: {
                        label: 'Order Category',
                        name: 'OrderCategory',
                        size: 'small',
                        lookupName: 'OrderCategory',
                        isLookupTypeFixed: true,
                        required: true,
                    }
                },
                {
                    id: 8,
                    type: 'EX_LOOKUP_FIELD',
                    props: {
                        label: 'User ID',
                        name: 'UserId',
                        size: 'small',
                        lookupName: 'Personnel',
                        isLookupTypeFixed: true,
                        required: true,
                    }
                },
                {
                    id: 9,
                    type: 'TEXT_FIELD',
                    props: {
                        label: 'PIN',
                        name: 'Pin',
                        placeholder: '****',
                        size: 'small',
                        type: 'password',
                        inputProps: {
                            maxLength: 4
                        },
                        required: false
                    }
                }
            ]
        }
    ]
};
export default ReceiptConfirmationForm;
